import { useLocation } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Check } from "@mui/icons-material";
import {Button} from "@mui/material";
import CirculerLoader from "../../components/Loader";
import googleImg from "../../assets/images/google.png";


const Password: React.FC = () => {
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname.includes("/login");
  const email = location.state?.email;
  
  const createUser = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    const baseURL = process.env.REACT_APP_BASE_URL;

    if (password.trim() !== "" && email) {
      if (isLoginPage || (password.trim() !== "" && password.trim().length >= 12)) {
        try {
          const response = await axios.post(isLoginPage ?`${baseURL}/user/login` :
            `${baseURL}/user/createUser`, {
            email: email,
            password: password
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
          localStorage.setItem("access_token", response.data.access_token);

          setLoading(false)
          if (response.data?.code !== 400) {
            if (isLoginPage) {
              navigate("/");
              localStorage.setItem("access_token", response.data.data);
            } else {
              navigate("/verification", { state: { email, Code: Number(response?.data?.data) } });
            }
          } else {
            setShowError(true)
          }
        } catch (error) {
          setLoading(false)
          console.log("error")
          setErrorMsg("The email address provided is already in use")
          // console.error('Error creating user:', error.response ? error.response.data : error.message);
        }
      }
    } else {
      alert("Add password")
    }
  };

  
  const forgotPassword = () => {
    
    navigate("/reset-password", { state: { email } });
  }


  return (
    <>
      <div className="password-inner-main" >
        <div className="password-inner-page" >
          {loading &&  <CirculerLoader/> }
          <h2 className="login-password">
            {isLoginPage ? "Enter your password" : "Create your account"}</h2>




          <div className="password-main-div" >
            <p style={{ color: "red" }}>{errorMsg}</p>
            <div className="email-edit">
              <span>{email} </span> {isLoginPage && <span onClick={() => {
                navigate("/authorize?type=login", { state: { email } });
              }} 
              
              className="edit-color">Edit</span>}
            </div>
            <form onSubmit={createUser}>
              <div className="input-container">
                <input
                  type={showPassword ? "text" : "password"} // Toggle password visibility
                  required
                  value={password}
                  onChange={(e) => { setPassword(e.target.value) }}
                  placeholder=" "
                />
                <label >Password*</label>
                <span 
                  className="eye-icon" 
                  onClick={() => setShowPassword(prevState => !prevState)} // Toggle password visibility
                >
                  {showPassword ? <VisibilityIcon/> : < VisibilityOffIcon/>} {/* Eye icon toggle */}
                </span>
              </div>
              {!isLoginPage && <>
                {password?.length >= 12 ? <>
                  <div className="check-inner">

                  <span>Your password must contain:</span>
                  <ul> <Check className="check-iconn"/> At least 12 characters</ul>
                  </div>
                </> : <>  {password?.length >= 1 && <>
                  <div className="check-inner">
                  <span> Your password must contain:</span>
                  <li> At least 12 characters</li>
                  </div>
                </>}
                </>}
              </>}
              {showError && password !== "" &&
                <p style={{ color: "red", fontSize: "12px" }}>Incorrect email address, phone number, or password. Phone numbers must include the country code.</p>
              }
              {isLoginPage &&
                <p className="password-align" onClick={forgotPassword} >Forgot password?</p>
              }
               <Button type="submit"variant="contained" sx={{ textTransform: "none" }}> Continue</Button>
              {!isLoginPage &&
                <a href="/authorize?type=signup" onClick={() => {
                  navigate("/authorize?type=signup", { state: { email } });
                }}>
                  Go back
                </a>
              }
            </form>
          </div>

          {isLoginPage ? <>
            <p className="account-login" >
              Don't have an account? <a href="/authorize?type=signup">
                Sign Up</a>
            </p>

            <div className="or-hr-page">
              <hr />
              <span >OR</span>
              <hr />
            </div>

            <div className="google-inner-part">
              <button onClick={() => {
                window.location.href = "https://scsbcback.makemagento.com/auth/login";
              }}>
                <img 
                // src="/google.png"
                         src={googleImg}
                
                alt="Google" />
                Continue with Google
              </button>
              
            </div>
          </> : ""}


        </div>
      </div>
      <div className="footer-innners">
        <p className="term-part" >
          <a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
        </p>
      </div>
    </>);
}
export default Password;